import { render, staticRenderFns } from "./BindSecret.vue?vue&type=template&id=3ddc6152&scoped=true"
import script from "./BindSecret.vue?vue&type=script&lang=js"
export * from "./BindSecret.vue?vue&type=script&lang=js"
import style0 from "./BindSecret.vue?vue&type=style&index=0&id=3ddc6152&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddc6152",
  null
  
)

export default component.exports